import { render, staticRenderFns } from "./page.vue?vue&type=template&id=0576cb1f"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0576cb1f')) {
      api.createRecord('0576cb1f', component.options)
    } else {
      api.reload('0576cb1f', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=0576cb1f", function () {
      api.rerender('0576cb1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page.vue"
export default component.exports